import { FETCH_GEOCODE_LOCATION_ADD, FETCH_GEOCODE_LOCATION_REQUEST, FETCH_GEOCODE_LOCATION_FAILURE } from "@/redux/actions";
const initialState = {
    data: {},
    loading: false,
    error: null,
};
const getGeoCodeLocationReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_GEOCODE_LOCATION_REQUEST:
            return Object.assign({}, state);
        case FETCH_GEOCODE_LOCATION_ADD: {
            return Object.assign(Object.assign({}, state), { loading: true, data: Object.assign(Object.assign({}, state.data), { [action.payload.searchString]: action.payload.data }) });
        }
        case FETCH_GEOCODE_LOCATION_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default getGeoCodeLocationReducer;
